import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  getCurrentUserUid() {
    return 'test...';
  }
}
